export const background_colors = (dark) => ({
    default: dark ? '#303030' : '#f0f0f0',
    paper: dark ? '#424242' : '#ffffff',
});
